import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "imageTemplate", "videoTemplate"];

  // Tracks object URLs so we can revoke them on close (only for blob: URLs).
  #activeObjectUrl = null;

  // Opened by window-level event: preview-modal:open
  // detail: { url: String, type: "image" | "video", revokeOnClose?: Boolean }
  open(event) {
    const { url, type, revokeOnClose } = event.detail || {};
    if (!url || !type) return;

    this.#clearContent();

    if (revokeOnClose) this.#activeObjectUrl = url;

    if (type === "image") {
      const node = this.imageTemplateTarget.content.cloneNode(true);
      const img = node.querySelector("img");
      img.src = url;
      this.contentTarget.appendChild(node);
    } else if (type === "video") {
      const node = this.videoTemplateTarget.content.cloneNode(true);
      const video = node.querySelector("video");
      video.src = url;
      this.contentTarget.appendChild(node);
      requestAnimationFrame(() => video.play().catch(() => {}));
    }

    this.element.hidden = false;
    // [hidden] is display:none, which can't transition — remove it, then add
    // the open class next frame so the fade-in actually animates.
    requestAnimationFrame(() => this.element.classList.add("preview-modal--open"));
    document.body.style.overflow = "hidden";
    this.element.focus();
  }

  close() {
    this.element.classList.remove("preview-modal--open");
    document.body.style.overflow = "";
    const duration = parseFloat(getComputedStyle(this.element).transitionDuration) * 1000;
    if (duration > 0) {
      this.element.addEventListener("transitionend", () => {
        this.element.hidden = true;
        this.#clearContent();
      }, { once: true });
    } else {
      this.element.hidden = true;
      this.#clearContent();
    }
  }

  backdropClick(e) {
    if (e.target === this.element) this.close();
  }

  modalKeydown(e) {
    if (e.key === "Escape") this.close();
  }

  #clearContent() {
    this.contentTarget.innerHTML = ""; // disconnects videojs controller → disposes player
    if (this.#activeObjectUrl) {
      URL.revokeObjectURL(this.#activeObjectUrl);
      this.#activeObjectUrl = null;
    }
  }
}
